
const courseOfferingRegisteredStatus = Object.freeze({
  ALL: "ALL",
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
});

export default courseOfferingRegisteredStatus;
